/** @jsx jsx */
import { jsx } from "theme-ui"
import { useState } from "react"
import { Link } from "gatsby"
import { RiMenu3Line, RiCloseLine } from "react-icons/ri"
import { websitesWithBlog } from "../util/const"
// import Menu from "./menu"

const MenuItems = [
  {
    path: "/",
    title: "Strona główna",
  },
  // {
  //   path: "/about",
  //   title: "About",
  // },
  websitesWithBlog
    .map(site => site.slug)
    .includes(process.env.GATSBY_PARKING_SLUG) && {
    path: "/blog",
    title: "Blog",
  },
  {
    path: "/kontakt",
    title: "Kontakt",
  },
].filter(item => item)

const ListLink = props => (
  <li>
    <Link to={props.to}>{props.children}</Link>
  </li>
)

const Navigation = () => {
  const [showMenu, setShowMenu] = useState(false)

  const handleToggleClick = () => setShowMenu(!showMenu)

  const listMenuItems = MenuItems.map((menuItem, index) => (
    <ListLink key={index} to={menuItem.path}>
      {menuItem.title}
    </ListLink>
  ))
  return (
    <nav className="site-navigation" sx={navStyle.menu}>
      <button
        aria-label="menu trigger"
        onClick={handleToggleClick}
        className={"menu-trigger" + (showMenu ? " is-active" : "")}
      >
        <div className="icon-menu-line">
          <RiMenu3Line />
        </div>
        <div className="icon-menu-close">
          <RiCloseLine />
        </div>
      </button>
      <ul>
        {listMenuItems}
        {/* <Menu /> */}
        <div sx={navStyle.border}></div>
        <div sx={navStyle.theme}></div>
      </ul>
    </nav>
  )
}

export default Navigation

const navStyle = {
  menu: {
    ul: {
      bg: "siteColor",
    },
  },
  theme: {
    display: ["block", "block", "block", "none"],
    p: " 25px 20px 20px",
  },
  border: {
    bg: "borderColor",
    borderTop: "1px solid transparent",
    display: ["block", "block", "block", "none"],
  },
}
